import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext } from "react";
import { defaultCurrency } from "@zapier/currency";
export const defaultUpgradeModalContext = {
    account: undefined,
    accountCurrency: defaultCurrency,
    activeTrialType: undefined,
    appLogoUrl: undefined,
    autoUpgradeToPlan: undefined,
    billingPeriodEndDate: null,
    billingPeriodStartDate: null,
    canExtendTrial: false,
    currentUserRole: "member",
    destinationPlan: undefined,
    enabledTrialExtensions: [],
    error: undefined,
    extendTrial: () => {
    },
    isAutoUpgradeEnabled: false,
    isLoading: false,
    isPaymentMethodProvided: false,
    taskBufferOverride: 0,
    tasksRemaining: 0,
};
export const UpgradeModalContext = createContext(defaultUpgradeModalContext);
export const UpgradeModalProvider = ({ children, upgradeModalData }) => (_jsx(UpgradeModalContext.Provider, { value: upgradeModalData, children: children }));

// @zapier/upsells@8.0.1 (466b4077f)
